import React from 'react'
import {FaPaperclip, FaComment} from 'react-icons/fa'
import {format} from 'date-fns'

interface TaskProps {
  task: {
    ticket_id: string
    title: string
    description: string
    issue: string
    created_at: string
    attachment: string
    solution: string
  }
  column: string
  handleDragStart: (e: React.DragEvent, taskId: string, fromColumn: string) => void
  openModal: (task: {
    ticket_id: string
    title: string
    description: string
    issue: string
    created_at: string
  }) => void
}

const RaiseTicketsCards: React.FC<TaskProps> = ({task, column, handleDragStart, openModal}) => {
  return (
    <div
      draggable
      onDragStart={(e) => handleDragStart(e, task.ticket_id, column)}
      onClick={() => openModal(task)}
      style={{
        padding: '15px',
        margin: '8px',
        backgroundColor: 'white',
        cursor: 'grab',
        borderRadius: '8px',
        boxShadow: '0px 2px 5px rgba(0,0,0,0.2)',
      }}
    >
      {/* Top Row - Issue Type and DateTime */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '8px',
        }}
      >
        {/* Issue Type Label using Metronic Badge */}
        <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
          {/* Issue Type Label using Metronic Badge */}
          <span
            className={`badge ${
              task.issue === 'task'
                ? 'badge-light-primary'
                : task.issue === 'bug'
                ? 'badge-light-danger'
                : task.issue === 'other'
                ? 'badge-light-warning'
                : 'badge-light-success'
            }`}
          >
            {task.issue}
          </span>

          {/* Date & Time */}
          <span style={{fontSize: '10px', color: '#888'}}>
            {format(new Date(task.created_at), 'dd-MMM-yyyy')}
          </span>
        </div>
      </div>

      {/* Task Title */}
      <h4 style={{margin: '10px 0', fontSize: '14px', fontWeight: '600'}}>{task.title}</h4>

      {/* Task Description */}
      <p style={{fontSize: '14px', color: '#555', marginBottom: '8px'}}>{task.description}</p>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginTop: '10px',
        }}
      >
        <button
          className='btn btn-secondary'
          style={{padding: '8px'}}
          onClick={() => openModal(task)}
        >
          Add Solution
        </button>
        {/* Icons Section */}
        <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
          {/* Attachment Icon with Count */}
          <div style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
            <FaPaperclip size={16} color=' #bfbfbf' />
            <span style={{fontSize: '12px'}}>{task.attachment ? task.attachment.length : 0}</span>
          </div>

          {/* Message Icon with Count */}
          <div style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
            <FaComment size={16} color=' #bfbfbf' />
            <span style={{fontSize: '12px'}}>{task.solution ? 1 : 0}</span>
          </div>
        </div>

        {/* Solution Button */}
      </div>

      <div style={{marginTop: '8px', fontSize: '14px', fontWeight: 'bold', textAlign: 'left'}}>
        Ticket ID: {task.ticket_id}
      </div>
    </div>
  )
}

export default RaiseTicketsCards
